import React, { useState } from 'react';
import cc from 'classcat';
import styles from './features.module.sass';
import { IconSVG } from '../SpriteSVG';
import { Icon } from '../Icon';
import { Button } from '../Button';

/**
 * Список для услуг
 */
export const Features = ({ features, ...props }) => {
  const [clipp, setClipp] = useState(8);
  return (
    <div>
      <ul className={styles.features} {...props}>
        {features && (
          <div className={styles.features}>
            {features.length <= 8
              ? features.map((i, id) => (
                  <li className={styles.featuresList} key={id}>
                    <Icon
                      rightGap={8}
                      icon={
                        <IconSVG
                          name={`services/${i.icon}`}
                          width={24}
                          height={24}
                        />
                      }
                    />
                    <span className={styles.featuresLabel}>
                      {i.facility_name}
                    </span>
                  </li>
                ))
              : features.slice(0, clipp).map((i, id) => (
                  <li className={styles.featuresList} key={id}>
                    <Icon
                      rightGap={8}
                      icon={
                        <IconSVG
                          name={`services/${i.icon}`}
                          width={24}
                          height={24}
                        />
                      }
                    />
                    <span className={styles.featuresLabel}>
                      {i.facility_name}
                    </span>
                  </li>
                ))}
          </div>
        )}
      </ul>
      {features && features.length > 8 && (
        <span className={styles.showMore}>
          <Button
            view={'white'}
            onClick={() => [
              setClipp(clipp === 8 ? features.length : 8),
              window.ym(
                35441960,
                'reachGoal',
                'cruise_page_expanded_full_list_of_onboard_services_section_description',
              ),
            ]}
          >
            {clipp === 8 ? 'Показать все услуги' : 'Скрыть'}
          </Button>
        </span>
      )}
    </div>
  );
};
